import React, {useMemo} from "react";
import {CallIcon} from "@hugeicons/core-free-icons";
import {green} from "@mui/material/colors";
import {MiniCard} from "./MiniCard";
import {PeriodMenu} from "./PeriodMenu";
import {ResponseTimeNavigation} from "./ResponseTimeNavigation";
import {useDashboard} from "../../../../context/DashboardContext";
import {hasActivity, toChartData} from "./response-time-utils";

export const ActiveCallsCard = () => {
    const {responseTime, activeCalls} = useDashboard();

    // Peak concurrent calls per bucket
    const chartData = useMemo(() => toChartData(responseTime?.ACTIVE_CALLS), [responseTime]);

    return (
        <MiniCard
            icon={CallIcon}
            color={green[400]}
            title={activeCalls}
            subtitle={"ACTIVE CALLS"}
            data={chartData}
            hideChart={!hasActivity(chartData)}
            action={<PeriodMenu type={"ACTIVE_CALLS"}/>}
            chartOverlay={<ResponseTimeNavigation type={"ACTIVE_CALLS"}/>}
            decimals={0}
        />
    );
};
